import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { UsersTypes } from '../_enums';

@Injectable({
  providedIn: 'root'
})
export class LoginAuthGuardGuard implements CanActivate {
  usersTypes = UsersTypes;
  constructor(private router: Router) {}
  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    const user = JSON.parse(localStorage.getItem('currentUser'));
    if (user) {
      // check token expired
      if (new Date(user.expiration) < new Date()) {
        localStorage.clear();
      } else if (this.usersTypes.Student === user.userType && !user.isLook) {
        this.router.navigate(['students']);
      } else if (this.usersTypes.SuperAdmin === user.userType && !user.isLook) {
        this.router.navigate(['Home/Main']);
      }
    }
    return true;
  }
}
